export const buildCategoryStats = (
  selectedCodesByCategory = {},
  completedCountByCategory,
) => {
  return Object.keys(selectedCodesByCategory)
    .map((category) => {
      const total = selectedCodesByCategory[category]?.length || 0;
      if (!total) return null;
      const completed = completedCountByCategory?.(category) || 0;
      const pending = Math.max(total - completed, 0);
      const percentage = total ? Math.round((completed / total) * 100) : 0;
      return { category, total, completed, pending, percentage };
    })
    .filter(Boolean);
};

export const buildDelegationSummary = (
  delegatedDisclosures = new Map(),
  isDisclosureCompleted,
) => {
  const summary = new Map();
  delegatedDisclosures.forEach((delegation, code) => {
    const email = delegation?.email || "Unknown";
    if (!summary.has(email)) {
      summary.set(email, { email, total: 0, completed: 0, disclosures: [] });
    }
    const entry = summary.get(email);
    const completed = Boolean(isDisclosureCompleted?.(code));
    entry.disclosures.push({ code, completed });
    entry.total += 1;
    if (completed) entry.completed += 1;
  });

  return Array.from(summary.values()).map((group) => ({
    ...group,
    percentage: group.total
      ? Math.round((group.completed / group.total) * 100)
      : 0,
  }));
};
